// extracted by mini-css-extract-plugin
export default {"links":"Catalogue_links__m7fPC","header":"Catalogue_header__GrYtb","cats":"Catalogue_cats__Yt4av","cat":"Catalogue_cat__LKkiD"};